"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FLOATING_PANEL_ACTIVE_PANEL_ID_KEY", {
  enumerable: true,
  get: function () {
    return _FloatingPanel3.FLOATING_PANEL_ACTIVE_PANEL_ID_KEY;
  }
});
Object.defineProperty(exports, "FLOATING_PANEL_CANCEL_CLASS", {
  enumerable: true,
  get: function () {
    return _FloatingPanel3.FLOATING_PANEL_CANCEL_CLASS;
  }
});
Object.defineProperty(exports, "FLOATING_PANEL_DEFAULT_HEIGHT", {
  enumerable: true,
  get: function () {
    return _FloatingPanel3.FLOATING_PANEL_DEFAULT_HEIGHT;
  }
});
Object.defineProperty(exports, "FLOATING_PANEL_DEFAULT_WIDTH", {
  enumerable: true,
  get: function () {
    return _FloatingPanel3.FLOATING_PANEL_DEFAULT_WIDTH;
  }
});
Object.defineProperty(exports, "FLOATING_PANEL_HANDLE_CLASS", {
  enumerable: true,
  get: function () {
    return _FloatingPanel3.FLOATING_PANEL_HANDLE_CLASS;
  }
});
Object.defineProperty(exports, "FLOATING_PANEL_MIN_HEIGHT", {
  enumerable: true,
  get: function () {
    return _FloatingPanel3.FLOATING_PANEL_MIN_HEIGHT;
  }
});
Object.defineProperty(exports, "FLOATING_PANEL_MIN_WIDTH", {
  enumerable: true,
  get: function () {
    return _FloatingPanel3.FLOATING_PANEL_MIN_WIDTH;
  }
});
Object.defineProperty(exports, "FLOATING_PANEL_RESIZE_HANDLE_CLASS", {
  enumerable: true,
  get: function () {
    return _FloatingPanel3.FLOATING_PANEL_RESIZE_HANDLE_CLASS;
  }
});
Object.defineProperty(exports, "FloatingPanel", {
  enumerable: true,
  get: function () {
    return _FloatingPanel2.default;
  }
});
exports.StyledFloatingPanel = void 0;

var FloatingPanelStyles = _interopRequireWildcard(require("./FloatingPanel.styles"));

var _FloatingPanel2 = _interopRequireDefault(require("./FloatingPanel"));

var _FloatingPanel3 = require("./FloatingPanel.consts");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledFloatingPanel = FloatingPanelStyles;
exports.StyledFloatingPanel = StyledFloatingPanel;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTdHlsZWRGbG9hdGluZ1BhbmVsIiwiRmxvYXRpbmdQYW5lbFN0eWxlcyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Zsb2F0aW5nUGFuZWwvaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0ICogYXMgRmxvYXRpbmdQYW5lbFN0eWxlcyBmcm9tICcuL0Zsb2F0aW5nUGFuZWwuc3R5bGVzJ1xuXG5leHBvcnQgeyBkZWZhdWx0IGFzIEZsb2F0aW5nUGFuZWwgfSBmcm9tICcuL0Zsb2F0aW5nUGFuZWwnXG5leHBvcnQge1xuICBGTE9BVElOR19QQU5FTF9BQ1RJVkVfUEFORUxfSURfS0VZLFxuICBGTE9BVElOR19QQU5FTF9DQU5DRUxfQ0xBU1MsXG4gIEZMT0FUSU5HX1BBTkVMX0RFRkFVTFRfSEVJR0hULFxuICBGTE9BVElOR19QQU5FTF9ERUZBVUxUX1dJRFRILFxuICBGTE9BVElOR19QQU5FTF9IQU5ETEVfQ0xBU1MsXG4gIEZMT0FUSU5HX1BBTkVMX01JTl9IRUlHSFQsXG4gIEZMT0FUSU5HX1BBTkVMX01JTl9XSURUSCxcbiAgRkxPQVRJTkdfUEFORUxfUkVTSVpFX0hBTkRMRV9DTEFTUyxcbn0gZnJvbSAnLi9GbG9hdGluZ1BhbmVsLmNvbnN0cydcbmV4cG9ydCB0eXBlIHsgRmxvYXRpbmdQYW5lbFBvc2l0aW9uLCBGbG9hdGluZ1BhbmVsUHJvcHMsIEZsb2F0aW5nUGFuZWxTaXplIH0gZnJvbSAnLi9GbG9hdGluZ1BhbmVsLnR5cGVzJ1xuZXhwb3J0IGNvbnN0IFN0eWxlZEZsb2F0aW5nUGFuZWwgPSBGbG9hdGluZ1BhbmVsU3R5bGVzXG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBRUE7O0FBQ0E7Ozs7OztBQVdPLE1BQU1BLG1CQUFtQixHQUFHQyxtQkFBNUIifQ==